export default "__VITE_ASSET__DLyk6Xq4__"